import { apiCmo } from "./apiCmo"

const customersApi = apiCmo.injectEndpoints({
  endpoints: (builder) => ({
    getEntitiesCmo: builder.query({
      query: () => "api/api/entidades",
    }),
    getMunicipalitiesCmo: builder.query({
      query: (id) => `api/api/municipios/${id}`,
    }),
    getAtcsCmo: builder.query({
      query: (id) => `api/api/atcs/${id}`,
    }),
    getCustomersCmo: builder.query({
      query: () => `api/api/clientes`,
    }),
    updateCustomerCmo: builder.mutation({
      query: (data) => ({
        url: `api/api/registrar_cliente/${data.idh}`,
        method: "POST",
        body: data,
      }),
    }),
  }),
})

export const {
  useGetEntitiesCmoQuery,
  useGetMunicipalitiesCmoQuery,
  useGetAtcsCmoQuery,
  useGetCustomersCmoQuery,
  useUpdateCustomerCmoMutation,
} = customersApi
